import axios from 'axios';
import localStorageService, { keys } from './../services/LocalStorageService'

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASEURL
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  config => {
    
    console.log(`request: ${config.method} ${config.url}`)
    config.headers['Content-Type'] = 'application/json';
    const user = localStorageService.getItem(keys.USER)
    if (user) {
      config.headers['Authorization'] = `Bearer ${user.token}`;
    }
    return config;
  }
)

// for multiple requests
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })
  failedQueue = [];
}

axiosClient.interceptors.response.use(function (response) {
  // Geen fouten, return response
  return response;
}, function (error) {

  if (!window.navigator.onLine) {
    // Indien offline direct reject
    logerror(-1, error)
    return Promise.reject('Offline');
  }

  if (!error.response) {
    logerror(-2, error)
    return Promise.reject(error)
  }
  const originalRequest = error.config;

  /* RH:volgens mij is aparte afhandeling login error overbodig
  if (error.response.status === 400 && originalRequest.url === '/Users/authenticate') {
    // Error bij inloggen  
    return Promise.reject(error);
  }
  */
  if (error.response.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject })
      }).then(token => {
        // requests in queue worden geresolved met het token
        originalRequest.headers['Authorization'] = 'Bearer ' + token;
        // waarom hier geen axiosClient zodat alle errors op 1 plaats binnenkomen...
        return axios(originalRequest);
      }).catch(err => {
        // waar komt deze reject vandaan?
        // wachtende requests terwijl er geen refresh token is!
        logerror(-3, err)
        return Promise.reject(err);
      })
    }

    // Refreshen token
    originalRequest._retry = true;
    isRefreshing = true;
    return new Promise(function (resolve, reject) {
      const user = localStorageService.getItem(keys.USER)
      axios.post(process.env.REACT_APP_BASEURL + '/users/refreshtoken', {
        "token": user.token,
        "refreshToken": user.refreshToken,
        "deviceId": localStorageService.getItem(keys.DEVICE)
      })
        .then(res => {
          const user = localStorageService.getItem(keys.USER);
          user.token = res.data.token;
          user.refreshToken = res.data.refreshToken;
          localStorageService.setItem(keys.USER, user);

          originalRequest.headers['Authorization'] = `Bearer ${res.data.token}`;
          processQueue(null, res.data.token);
          // deze error kan hier niet worden afgevangen...
          resolve(axiosClient(originalRequest));
        })
        .catch((err) => {
          logerror(-4, err)
          processQueue(err, null);
          reject(err);
        })
        .then(() => { isRefreshing = false })
    })
  } else {
    logerror(-5, error)
    return Promise.reject(error)
  }
});

const logerror= (level, error) => {
  //todo: bepalen wat en wanneer er gelogd moet worden. Non 200 responses worden nu ook al door de api gelogd
  //console.log(`logerror: ${level}:`, error.response.status, JSON.stringify(error.response.data))
}

export default axiosClient;